import { Wrench, GraduationCap, HeartHandshake, Factory } from "lucide-react";
import Reveal from "@/components/Reveal";
import { IMAGES, BIZ } from "@/constants/content";

const FACTS = [
  { icon: Wrench, k: "10+ years", v: "hands-on experience" },
  { icon: GraduationCap, k: "200+ hours", v: "specialized training" },
  { icon: Factory, k: "Factory-trained", v: "precision guaranteed" },
  { icon: HeartHandshake, k: "Family-owned", v: "two brothers, one shop" },
];

export default function Story() {
  return (
    <section id="story" className="relative overflow-hidden bg-white py-20 sm:py-28" data-testid="story-section">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
        <div className="relative lg:col-span-6">
          <Reveal>
            <div className="relative overflow-hidden rounded-[26px] shadow-[0_30px_80px_rgba(22,50,79,0.18)]" data-testid="story-image-main">
              <img src={IMAGES.handpieces} alt="Dental handpieces on the bench" className="aspect-[4/3] w-full object-cover" />
              <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(110%_80%_at_15%_10%,rgba(234,76,137,0.18),transparent_50%)]" />
            </div>
            <div className="absolute -bottom-8 right-4 w-2/5 overflow-hidden rounded-2xl border-4 border-white shadow-xl sm:-right-4" data-testid="story-image-inset">
              <img src={IMAGES.workshop} alt="Precision repair work" className="aspect-[4/3] w-full object-cover" />
            </div>
            <div className="absolute left-4 top-4 rounded-full bg-brandpink px-4 py-1.5 text-[11.5px] font-extrabold uppercase tracking-wider text-white shadow-lg" data-testid="story-badge">
              Family owned · Buffalo, NY
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          <Reveal>
            <p className="eyebrow text-brandsky-deep">Our story — the Dental Bros</p>
            <h2 className="font-display mt-3 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl lg:text-[2.75rem] lg:leading-[1.05]">
              Two brothers. One workbench.
              <br />
              In the family since age 15.
            </h2>
          </Reveal>
          <Reveal delay={0.08}>
            <div className="mt-6 space-y-4 text-[15.5px] leading-relaxed text-slate-600" data-testid="story-copy">
              <p>
                JSL Dental Repair was founded by two brothers born and raised in Buffalo, NY —{" "}
                <strong className="font-semibold text-ink">Jacob and Jonah LaCarrubba</strong>. We grew up working
                with our hands, and our journey into dentistry began at 15, alongside our father,{" "}
                <strong className="font-semibold text-ink">Dr. Bob</strong>, a respected dentist in the community.
              </p>
              <p>
                Lifelong Buffalo Bills fans, we share a deep-rooted connection to this city. Today we put{" "}
                10+ years of experience and 200+ hours of specialized factory training into every handpiece that
                crosses our bench — and treat your practice like it's family, because ours is too.
              </p>
              <p className="font-display border-l-4 border-brandpink pl-4 text-lg font-bold italic text-ink">
                "{BIZ.tagline}"
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.14}>
            <dl className="mt-9 grid grid-cols-2 gap-4" data-testid="story-facts">
              {FACTS.map((f) => (
                <div key={f.k} className="rounded-2xl border border-ink/10 bg-paper p-4">
                  <f.icon className="h-5 w-5 text-brandsky-deep" />
                  <div className="font-display mt-2.5 text-[17px] font-extrabold text-ink">{f.k}</div>
                  <div className="text-[12.5px] text-slate-500">{f.v}</div>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>
      </div>
    </section>
  );
}